<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle"></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img :src="img" alt="Circle Image" class="img-raised rounded-circle img-fluid" />
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h4 class="title">
                      Por que Nome a Pessoa Ofendida te Conhece?
                    </h4>
                    <md-field>
                      <label>Seu Nome</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h4 class="title">
                      Qual o Nome da Pessoa Ofendida?
                    </h4>
                    <md-field>
                      <label>Nome da Pessoa</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h4 class="title">
                      O que Você Fez?
                    </h4>
                    <md-field maxlength="5">
                      <label>Ação que Requer Retratação</label>
                      <md-textarea v-model="message"></md-textarea>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <h4 class="title">
                      O que a Pessoa Ofendida é Seu/Sua?
                    </h4>

                    <v-list link>
                      <v-list-item-group v-model="tiposX.selectedItem" color="primary">
                        <v-list-item v-for="(item, i) in tiposX.items" :key="i">
                          <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.text"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </div>

                  <div class="md-layout-item md-size-50">
                    <h4 class="title">
                      Sua Atitude Foi
                    </h4>

                    <div class="flex-column" style="display: grid; text-align: center;">
                      <md-checkbox v-model="checkbox1">Ofensiva</md-checkbox>
                      <md-checkbox v-model="checkbox2">Pertubadora</md-checkbox>
                      <md-checkbox v-model="checkbox3">Egoísta</md-checkbox>
                      <md-checkbox v-model="checkbox4">Nociva</md-checkbox>
                      <md-checkbox v-model="checkbox5">Engraçada</md-checkbox>
                    </div>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h4 class="title">
                      O que a Sua Ação Gerou?
                    </h4>
                    <md-field maxlength="5">
                      <label>"Eu nunca pretendi..."</label>
                      <md-textarea v-model="message"></md-textarea>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h4 class="title">
                      Motivo Percebido
                    </h4>
                    <md-field maxlength="5">
                      <label>Motivo</label>
                      <md-textarea v-model="message"></md-textarea>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h4 class="title" style="padding: 25px;">
                      Grau de Sinceridade
                    </h4>

                    <img :src="sinceridadesImg[sinceridade]" style="max-width: min-content;" />

                    <v-slider v-model="sinceridade" :tick-labels="sinceridades" :max="2" step="1" ticks="always"
                      tick-size="2">
                    </v-slider>
                  </div>
                </div>

                <div class="md-layout" style="padding-bottom: 20px;">
                  <div class="md-layout-item md-size-50 md-small-size-100">
                    <h4 class="title">
                      Você se Sente
                    </h4>
                    <div class="flex-column" style="display: grid;">
                      <md-checkbox v-model="checkbox1">Terrível</md-checkbox>
                      <md-checkbox v-model="checkbox2">Culpado</md-checkbox>
                      <md-checkbox v-model="checkbox3">Estúpido</md-checkbox>
                      <md-checkbox v-model="checkbox4">Arrependido</md-checkbox>
                      <md-checkbox v-model="checkbox5">Inocente</md-checkbox>
                      <md-checkbox v-model="checkbox5">Absolvido</md-checkbox>
                      <md-checkbox v-model="checkbox5">Melhor</md-checkbox>
                    </div>
                  </div>

                  <div class="md-layout-item md-size-50 md-small-size-100">
                    <h4 class="title">
                      Por Favor
                    </h4>
                    <div class="flex-column text-center" style="display: grid;">
                      <md-checkbox v-model="checkbox1">Me Perdoe</md-checkbox>
                      <md-checkbox v-model="checkbox2">Seja Paciente Comigo</md-checkbox>
                      <md-checkbox v-model="checkbox3">Me dê Outra Chance</md-checkbox>
                      <md-checkbox v-model="checkbox4">Esqueça o que Aconteceu</md-checkbox>
                      <md-checkbox v-model="checkbox5">Não se Vingue</md-checkbox>
                      <md-checkbox v-model="checkbox5">Não Chame a Polícia</md-checkbox>
                      <md-checkbox v-model="checkbox5">Não Conte pros Meus Pais</md-checkbox>
                    </div>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h4 class="title">
                      Notas Adicionais
                    </h4>
                    <md-field maxlength="5">
                      <label>Motivo</label>
                      <md-textarea v-model="message"></md-textarea>
                    </md-field>
                  </div>
                </div>
                
                <br/>

                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button class="md-success">Enviar</md-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

//import { FormWizard, TabContent } from 'vue-form-wizard'
//import 'vue-form-wizard/dist/vue-form-wizard.min.css'
/*
  components: {
    FormWizard,
    TabContent
  },
*/
export default {
  bodyClass: "profile-page",
  data() {
    return {
      checkbox1: true,
      checkbox2: null,
      checkbox3: true,
      checkbox4: null,
      checkbox5: null,
      radio1: true,
      radio2: null,
      radio3: null,
      radio4: null,
      radio5: null,
      radio6: null,
      radio7: null,
      tabPane1: [
        { image: require("@/assets/img/examples/studio-1.jpg") },
        { image: require("@/assets/img/examples/studio-2.jpg") },
        { image: require("@/assets/img/examples/studio-4.jpg") },
        { image: require("@/assets/img/examples/studio-5.jpg") }
      ],
      tabPane2: [
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/cynthia-del-rio.jpg") },
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/clem-onojegaw.jpg") }
      ],
      tabPane3: [
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/studio-3.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/studio-1.jpg") }
      ],
      tiposX: {
        selectedItem: 1,
        items: [
          { text: 'Conjugue', icon: 'people' },
          { text: 'Namorada(o)', icon: 'favorite' },
          { text: 'País', icon: 'baby_changing_station' },
          { text: 'Irmã(o)', icon: 'groups_2' },
          { text: 'Parente', icon: 'diversity_3' },
          { text: 'Amigo(a)', icon: 'person_add' },
          { text: 'Colega', icon: 'social_distance' },
          { text: 'Alguém do Serviço', icon: 'engineering' },
          { text: 'Chefe', icon: 'contact_emergency' }
        ]
      },
      sinceridade: 0,
      sinceridades: [
        'De Coração',
        'Relutante',
        'Técnico'
      ],
      sinceridadesImg: [
        'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/72/apple/325/pleading-face_1f97a.png',
        'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/72/apple/325/face-with-diagonal-mouth_1fae4.png',
        'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/72/apple/325/expressionless-face_1f611.png'
      ]
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg_foimal02.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>